(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsen-modal/assets/javascripts/sticky-bottom.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsen-modal/assets/javascripts/sticky-bottom.js');
"use strict";

const _svs$ui = svs.ui,
  ReactButton = _svs$ui.ReactButton,
  ReactIcon = _svs$ui.ReactIcon;
const TipsenLink = svs.components.tipsen.tipsen_link.TipsenLink;
const StickyBottomButton = _ref => {
  let _ref$isBlock = _ref.isBlock,
    isBlock = _ref$isBlock === void 0 ? false : _ref$isBlock,
    _ref$isThin = _ref.isThin,
    isThin = _ref$isThin === void 0 ? false : _ref$isThin,
    _ref$isInverted = _ref.isInverted,
    isInverted = _ref$isInverted === void 0 ? false : _ref$isInverted,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isTransparent = _ref.isTransparent,
    isTransparent = _ref$isTransparent === void 0 ? false : _ref$isTransparent,
    children = _ref.children,
    onClick = _ref.onClick;
  return React.createElement(ReactButton, {
    block: isBlock,
    className: "sticky-bottom-nav",
    disabled: isDisabled,
    inverted: isInverted,
    onClick: onClick,
    thin: isThin,
    transparent: isTransparent
  }, children);
};
setGlobal('svs.components.tipsen.tipsenModal.StickyBottomButton', StickyBottomButton);
const StickyBottomLink = _ref2 => {
  let _ref2$isBlock = _ref2.isBlock,
    isBlock = _ref2$isBlock === void 0 ? false : _ref2$isBlock,
    _ref2$isThin = _ref2.isThin,
    isThin = _ref2$isThin === void 0 ? false : _ref2$isThin,
    _ref2$isInverted = _ref2.isInverted,
    isInverted = _ref2$isInverted === void 0 ? true : _ref2$isInverted,
    _ref2$isDisabled = _ref2.isDisabled,
    isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled,
    _ref2$isTransparent = _ref2.isTransparent,
    isTransparent = _ref2$isTransparent === void 0 ? false : _ref2$isTransparent,
    children = _ref2.children,
    to = _ref2.to;
  return React.createElement(TipsenLink, {
    to: to
  }, React.createElement(StickyBottomButton, {
    isBlock: isBlock,
    isDisabled: isDisabled,
    isInverted: isInverted,
    isThin: isThin,
    isTransparent: isTransparent
  }, children));
};
setGlobal('svs.components.tipsen.tipsenModal.StickyBottomLink', StickyBottomLink);
const StickyButtonClose = _ref3 => {
  let onClick = _ref3.onClick,
    to = _ref3.to,
    _ref3$isInverted = _ref3.isInverted,
    isInverted = _ref3$isInverted === void 0 ? true : _ref3$isInverted,
    _ref3$isTransparent = _ref3.isTransparent,
    isTransparent = _ref3$isTransparent === void 0 ? false : _ref3$isTransparent;
  const buttonText = 'Stäng';
  return to ? React.createElement(StickyBottomLink, {
    isBlock: true,
    isInverted: isInverted,
    isThin: true,
    isTransparent: isTransparent,
    to: to
  }, buttonText) : React.createElement(StickyBottomButton, {
    isBlock: true,
    isInverted: isInverted,
    isThin: true,
    isTransparent: isTransparent,
    onClick: onClick
  }, buttonText);
};
setGlobal('svs.components.tipsen.tipsenModal.StickyButtonClose', StickyButtonClose);
const StickyButtonIcon = _ref4 => {
  let onClick = _ref4.onClick,
    icon = _ref4.icon;
  return React.createElement(StickyBottomButton, {
    icon: icon,
    isThin: true,
    isTransparent: true,
    onClick: onClick
  }, React.createElement(ReactIcon, {
    icon: icon,
    size: "100"
  }));
};
setGlobal('svs.components.tipsen.tipsenModal.StickyButtonIcon', StickyButtonIcon);
const StickyNavLink = _ref5 => {
  let ariaLabel = _ref5.ariaLabel,
    icon = _ref5.icon,
    pathname = _ref5.pathname,
    searchParams = _ref5.searchParams;
  return React.createElement(TipsenLink, {
    "aria-label": ariaLabel,
    to: {
      pathname,
      search: "?".concat(searchParams)
    }
  }, React.createElement(StickyButtonIcon, {
    icon: icon
  }));
};
setGlobal('svs.components.tipsen.tipsenModal.StickyNavLink', StickyNavLink);
const StickyBottom = _ref6 => {
  let className = _ref6.className,
    _ref6$hasEvenplacemen = _ref6.hasEvenplacement,
    hasEvenplacement = _ref6$hasEvenplacemen === void 0 ? true : _ref6$hasEvenplacemen,
    children = _ref6.children;
  const classNames = ['sticky-bottom'];
  if (className && className.length > 0) {
    classNames.push(className);
  }
  if (!hasEvenplacement) {
    classNames.push('sticky-bottom-not-evenly');
  }
  return React.createElement("div", {
    className: classNames.join(' ')
  }, children);
};
setGlobal('svs.components.tipsen.tipsenModal.StickyBottom', StickyBottom);

 })(window);